import { render } from "./YardimGovde.vue?vue&type=template&id=45420dee"
import script from "./YardimGovde.vue?vue&type=script&lang=js"
export * from "./YardimGovde.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__